import { render, staticRenderFns } from "./themePc.vue?vue&type=template&id=20e70f98&scoped=true"
import script from "./themePc.vue?vue&type=script&lang=js"
export * from "./themePc.vue?vue&type=script&lang=js"
import style0 from "./themePc.vue?vue&type=style&index=0&id=20e70f98&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e70f98",
  null
  
)

export default component.exports